import { Request } from 'express';
import { ReactElement } from 'react';
import { TrackPageViewContainer } from '../../../common/containers/TrackPageViewContainer';
import { getDehydratedState } from '../../../common/getDehydrateState';
import { t } from '../../../common/getTranslations';
import { Layout } from '../../../design-system/layout/Layout';
import PageLayout from '../../../domain/landing/presentational';
import { ApiErrorBoundary } from '../../../errors/ApiErrorBoundary.class';
import { addError } from '../../../errors/ErrorSlice';
import { thunkSerializeError } from '../../../errors/thunkSerializeError.function';
import { StaticLandingTodayUpLayoutQuery, StaticLandingTodayUpLayoutQueryVariables, StaticLandingTodayUpSection, StaticLandingType } from '../../../graphql/generated/types';
import { CommonMobileHeaderType } from '../../../header/constants';
import { PageViewCustomPropsDataKey } from '../../../logging/PageViewCustomPropsDataKey.enum';
import { setLayout } from '../../../pagewebLayout/PagewebLayoutSlice';
import { nextReduxWrapper } from '../../../state/store';
import { STATIC_LANDING_PAGE_NAME_MAP, STATIC_LANDING_PAGE_SECTION_NAME } from '../../../staticLanding/constants';
import { queryStaticLandingLayout } from '../../../staticLanding/queryStaticLandingLayout';
import { STATIC_LANDING_TODAY_UP_CATEGORY_LIST } from '../../../staticLanding/todayUp/constants';
function StaticLandingTodayUp({
  layoutId
}: {
  layoutId: string;
}) {
  return <>
      <ApiErrorBoundary>
        <PageLayout id={layoutId} />
      </ApiErrorBoundary>
      <TrackPageViewContainer trackObj={{
      section: STATIC_LANDING_PAGE_SECTION_NAME,
      page: STATIC_LANDING_PAGE_NAME_MAP[StaticLandingType.TodayUp],
      actionType: 'Pageview',
      actionName: `${STATIC_LANDING_PAGE_NAME_MAP[StaticLandingType.TodayUp]}_화면`,
      customProps: {
        user_action: 'pv'
      }
    }} customPropsDataKeyList={[PageViewCustomPropsDataKey.PageCategoryFilter, PageViewCustomPropsDataKey.PageGenreFilter]} />
    </>;
}
StaticLandingTodayUp.getInitialProps = nextReduxWrapper.getInitialPageProps(store => async context => {
  const cookie = context?.req?.headers.cookie;
  const uidInfoList = context.query?.pathParams as string[];
  if (!uidInfoList || uidInfoList.length === 0) {
    return {
      notFound: true
    };
  }
  try {
    const {
      data,
      queryClient
    } = await queryStaticLandingLayout<StaticLandingTodayUpLayoutQuery, StaticLandingTodayUpLayoutQueryVariables>({
      ssrRequest: context.req as Request,
      type: StaticLandingType.TodayUp,
      cookie,
      uidInfoList,
      fetchQueryOptions: {
        staleTime: 0,
        gcTime: 0
      }
    });
    if (!data || !data.staticLandingTodayUpLayout) {
      throw new Error('오늘UP 고정랜딩 레이아웃 데이터가 없습니다.');
    }
    const layoutId = data.staticLandingTodayUpLayout.id;
    // redux에 레이아웃 정보가 없을 때만 setLayout으로 값을 초기화 해줍니다.
    if (!store.getState().pagewebLayout.entities.layouts[layoutId]) {
      store.dispatch(setLayout({
        layout: data.staticLandingTodayUpLayout
      }));
    }
    const staticLandingTodayNewSection = data.staticLandingTodayUpLayout.sections[0] as StaticLandingTodayUpSection;
    return {
      layoutId,
      categoryName: STATIC_LANDING_TODAY_UP_CATEGORY_LIST.find(categoryInfo => categoryInfo.id === staticLandingTodayNewSection.param.categoryUid)?.text,
      subcategoryName: staticLandingTodayNewSection.param.subcategory?.name,
      ...getDehydratedState(queryClient)
    };
  } catch (error) {
    store.dispatch(addError({
      error: thunkSerializeError(error)
    }));
    return {
      layoutId: ''
    };
  }
});
StaticLandingTodayUp.getLayout = function getLayout(page: ReactElement) {
  const {
    categoryName,
    subcategoryName
  } = page.props;
  return <Layout title={t('landing_up')} mobileLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: true,
    headerType: CommonMobileHeaderType.TwoDepth,
    headerCustomTiaraObject: {
      customProps: {
        page_category_filter: categoryName,
        page_genre_filter: subcategoryName
      }
    }
  }} pcLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: true
  }}>
      {page}
    </Layout>;
};
export default StaticLandingTodayUp;